import { useState, useEffect } from "react";
import { EMPLOYEE_MANAGEMENT_SERVICE } from "src/utils/Api";
import __ from "src/utils/Translations";
import sendBatchRequests from "src/utils/Api/sendBatchRequests";

export default function useOrganizationUnits(
  asOption = false,
  filterField = null,
  filterValue = null,
  idAsIri = false,
  noFetching = false
) {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () =>
      sendBatchRequests({
        skipAction: noFetching,
        filterField,
        filterValue,
        idAsIri,
        asOption,
        IRI_PREFIX,
        requestParams: {
          service: EMPLOYEE_MANAGEMENT_SERVICE,
          path: "/organization-units",
          method: "GET",
          mockData,
          additionalParams: {
            "order[name]": "asc",
          },
        },
        setData,
      });

    fetchData();
  }, [filterField, filterValue, idAsIri, asOption, noFetching, setData]);

  return data;
}

export const IRI_PREFIX = "/api/employee-management/v1/rest/organization-units";

export const mockData = [
  {
    id: "a43275e4-eeb2-11ea-adc1-0242ac1200021",
    companyId: "a43275e4-eeb2-11ea-adc1-0242ac1200021",
    name: "Jednostka główna",
    language: "pl",
    description: "Opis jednostki testowej",
    ahrGroups: [
      "a43275e4-eeb2-11ea-adc1-0242ac1200021",
      "a43275e4-eeb2-11ea-adc1-0242ac1200022",
      "a43275e4-eeb2-11ea-adc1-0242ac1200023",
    ],
    availableAdministrators: [
      "a43275e4-eeb2-11ea-adc1-0242ac1200021",
      "a43275e4-eeb2-11ea-adc1-0242ac1200022",
      "a43275e4-eeb2-11ea-adc1-0242ac1200023",
    ],
  },
  {
    id: "a43275e4-eeb2-11ea-adc1-0242ac1200022",
    companyId: "a43275e4-eeb2-11ea-adc1-0242ac1200021",
    name: "Jednostka regionalna",
    language: "pl",
    description: "Opis jednostki testowej",
    ahrGroups: [
      "a43275e4-eeb2-11ea-adc1-0242ac1200021",
      "a43275e4-eeb2-11ea-adc1-0242ac1200022",
      "a43275e4-eeb2-11ea-adc1-0242ac1200023",
    ],
    availableAdministrators: [
      "a43275e4-eeb2-11ea-adc1-0242ac1200021",
      "a43275e4-eeb2-11ea-adc1-0242ac1200022",
      "a43275e4-eeb2-11ea-adc1-0242ac1200023",
    ],
  },
];
